var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_5366",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.511353,
    y: 0.256104,
    width: 15.4877,
    height: 15.4877,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_5366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_2",
    d: "M13.1224 13.5352L9.06934 9.48206C8.74668 9.74846 8.37562 9.95694 7.95616 10.1075C7.53671 10.2581 7.10277 10.3334 6.65436 10.3334C5.5514 10.3334 4.61794 9.95149 3.85397 9.18771C3.08999 8.42393 2.70801 7.49071 2.70801 6.38804C2.70801 5.28536 3.0899 4.3518 3.85368 3.58734C4.61745 2.8229 5.55068 2.44067 6.65336 2.44067C7.75603 2.44067 8.68959 2.82266 9.45405 3.58663C10.2185 4.3506 10.6007 5.28407 10.6007 6.38703C10.6007 6.84785 10.5234 7.28799 10.3687 7.70745C10.2139 8.1269 10.0075 8.49176 9.74939 8.80201L13.8025 12.8551L13.1224 13.5352ZM6.65436 9.36543C7.48583 9.36543 8.1901 9.0769 8.76717 8.49984C9.34423 7.92277 9.63277 7.2185 9.63277 6.38703C9.63277 5.55555 9.34423 4.85129 8.76717 4.27422C8.1901 3.69715 7.48583 3.40862 6.65436 3.40862C5.82289 3.40862 5.11862 3.69715 4.54155 4.27422C3.9645 4.85129 3.67597 5.55555 3.67597 6.38703C3.67597 7.2185 3.9645 7.92277 4.54155 8.49984C5.11862 9.0769 5.82289 9.36543 6.65436 9.36543Z",
    fill: "#4A4A4A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a7a02c8a2bb53c92dfa812d32764c3ad.svg";
export { ForwardRef as ReactComponent };